import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { MAIN_ROUTE } from '../../app.routes';

@Injectable({ providedIn: 'root' })
export class LoginRedirectGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    if (this.auth.isLogged()) {
      return this.router.createUrlTree(MAIN_ROUTE.split('/').filter(Boolean));
    }
    return true;
  }
}
